export const equalTo = <T>(a: T) => (b: T) => a === b;
